import { _ep0, _mw0, command } from "../commandBuilder";
import { GetBaptism$ } from "../schemas/schemas_0";
export class GetBaptismCommand extends command(_ep0, _mw0, "GetBaptism", GetBaptism$) {
}
